<template>
  <label class="icon-box" @click="openModal">
    <auth-img class="icon-img" :src="wecomIcon" alt="" />
    <div class="icon-label">引导患者加入微信群</div>
  </label>
  <a-modal
    v-model:visible="modalVisible"
    title="邀请患者加入微信群"
    cancelText="取 消"
    okText="发送"
    wrapClassName="wecom-qrcode-modal"
    :width="454"
    :bodyStyle="{ padding: '20px 110px 31px' }"
    :confirm-loading="sending"
    :ok-button-props="{ disabled: loading || sending || !qrCode }"
    centered
    @ok="confirmSend"
    @cancel="closeModal"
  >
    <a-spin :spinning="loading">
      <div class="qr-code-content">
        <img class="qr-code-background" :src="qrcodeBox" alt="" />
        <auth-img v-if="qrCode" mode="native" class="qr-code" :src="qrCode" alt="企业微信二维码" />
      </div>
    </a-spin>
  </a-modal>
</template>

<script setup>
import { defineProps, ref } from 'vue'
import wecomIcon from '@/assets/img/chat/wecom.png'
import qrcodeBox from '@/assets/img/chat/qrcodeBox.png'
import { getWeComQrCode } from '@/api/workPlace/enterpriseWeChatRecord'
import useGuideQrCodeImageSender from './useGuideQrCodeImageSender'

const props = defineProps({
  ucDoctorId: {
    type: [String, Number],
    default: ''
  },
  ucPatientId: {
    type: [String, Number],
    default: ''
  },
  workOrderId: {
    type: [String, Number],
    default: ''
  },
  chatId: {
    type: [String, Number],
    default: ''
  },
  chatToType: {
    type: String,
    default: 'private'
  }
})
const { sendQrCodeImage } = useGuideQrCodeImageSender()

const modalVisible = ref(false)
const loading = ref(false)
const sending = ref(false)
const qrCode = ref('')

const openModal = async () => {
  modalVisible.value = true
  qrCode.value = ''
  if (!props.ucDoctorId || !props.ucPatientId) return

  loading.value = true
  try {
    const result = await getWeComQrCode({
      ucDoctorId: String(props.ucDoctorId),
      ucPatientId: String(props.ucPatientId),
      entryScene: 9
    })
    qrCode.value = result?.qrCode || ''
  } catch {
    qrCode.value = ''
  } finally {
    loading.value = false
  }
}

const closeModal = () => {
  modalVisible.value = false
  sending.value = false
}

const confirmSend = async () => {
  if (!qrCode.value || loading.value || sending.value) return
  sending.value = true
  const success = await sendQrCodeImage({
    url: qrCode.value,
    chatId: props.chatId,
    chatToType: props.chatToType,
    ucDoctorId: props.ucDoctorId,
    ucPatientId: props.ucPatientId,
    workOrderId: props.workOrderId
  })
  if (success) closeModal()
  else sending.value = false
}
</script>

<style scoped lang="scss">
@import '../../index.scss';

.icon-box {
  width: 126px;
}

.qr-code-content {
  position: relative;
  width: 234px;
  height: 234px;
}

.qr-code-background {
  position: absolute;
  inset: 0;
  width: 234px;
  height: 234px;
}
.qr-code {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 210px;
  height: 210px;
}
</style>

<style lang="scss">
.wecom-qrcode-modal {
  .ant-modal-content {
    height: 391px;
    overflow: hidden;
    border-radius: 4px;
  }

  .ant-modal-header {
    height: 49px;
    padding: 13px 24px;
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-modal-title {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }

  .ant-modal-close {
    top: 14px;
    right: 24px;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }

  .ant-modal-close-x {
    width: 20px;
    height: 20px;
    line-height: 20px;
  }

  .ant-modal-body {
    height: 285px;
    box-sizing: border-box;
  }

  .ant-modal-footer {
    height: 57px;
    padding: 0 24px 24px;
    border-top: 0;

    .ant-btn {
      height: 32px;
      font-size: 14px;
    }

    .ant-btn-default {
      width: 64px;
    }

    .ant-btn-primary {
      width: 88px;
      margin-left: 8px;
    }
  }
}
</style>
